module.exports = "<my-owner-create-form my-owner=\"$$owner.data.myOwner\"\n  enable-title=\"true\"\n  enable-contacts=\"true\">\n</my-owner-create-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/owner/templates/new.html
// module id = 1508
// module chunks = 0